<template>
  <div v-if="isShowLoading" id="d3-loading-background">
    <div id="d3-loading-container">
      <div id="d3-loading-body">
        <div class="mdl-spinner mdl-js-spinner is-active"></div>
        <div v-if="message" id="d3-loading-message">{{ message }}</div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  @import "../../global-variables";

  #d3-loading-background {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 5;
    background: rgba(0, 0, 0, 0.7);
  }

  #d3-loading-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    height: 100%;
  }

  #d3-loading-body {
    text-align: center;
    display: table-cell;
    vertical-align: middle;
    width: 300px;
    color: $text-white;
  }

  #d3-loading-message {
    margin-top: 10px;
  }
</style>

<script>
  export default{
    data(){
      return {
        isShowLoading: false,
        message:       null
      };
    },

    methods: {
      show(message = null){
        this.isShowLoading = true;
        this.message       = message;
      },

      hide(){
        this.isShowLoading = false;
      }
    },

    created(){
      this.$root.$on('show-loading', this.show);
      this.$root.$on('hide-loading', this.hide);
    },

    beforeDestroy(){
      this.$root.$off('show-loading', this.show);
      this.$root.$off('hide-loading', this.hide);
    }
  };
</script>



// WEBPACK FOOTER //
// Loading.vue?2b7bfde5